const defaultFooterIds = {
  dev: 1,
  master: 1,
  prod: 1,
  'pre-prod': 1,
}

const giFooterIds = {
  dev: 2,
  master: 2,
  prod: 2,
  'pre-prod': 2,
}

const lifeFooterIds = {
  dev: 3,
  master: 3,
  prod: 3,
  'pre-prod': 3,
}

export enum FooterType {
  DEFAULT = 'default',
  GI = 'gi',
  LIFE = 'life',
}

export const getGlobalFooterID = (env: string, type = FooterType.DEFAULT): string | number => {
  switch (type) {
    case FooterType.GI:
      return giFooterIds[env] || 1
    case FooterType.LIFE:
      return lifeFooterIds[env] || 1
    default:
      return defaultFooterIds[env] || 1
  }
}
